<template>
    <div class="cloud">
        <div :class="['top','clearfix']">
            <div class="topBg"></div>
            <div class="topContent clearfix">
                <img src="/cloud/logoT.png" class="topLogo"/>
                <!-- <div class="meunList clearfix">
                    <div class="meun">共享云仓</div>
                    <div class="meun">在线金融</div>
                </div> -->
                <div class="cloudReturnBox clearfix" @click="gotoShop">
                    <img src="/icon/cloudReturn.png" class="cloudReturn"/>
                    <div class="cloudReturnName">返回云链</div>
                </div>
            </div>
        </div>
        <div class="carContent clearfix">
            <div v-if="total>0">
                <div class="carTop clearfix">
                    <div class="all">全部商品（{{total}}）</div>
                    <!-- <div class="selectAllCompanyBox clearfix">
                        <div class="name">全选</div>
                        <img :src="item.isChecked?'/cloud/checked.png':'/cloud/check.png'" @click="selectProP(item.id)" class="carClassAll"/>
                    </div> -->
                    <div class="carSearchBox clearfix">
                        <input class="carSearchInp" v-model="param.keyword" placeholder="请输入货主，区域或仓库搜索"/>
                        <div class="searchBtn" @click="getList(true)">搜索</div>
                    </div>
                </div>
                <div class="carClass">
                    <div v-for="item in carList" :key="item.company_id">
                        <div class="carClassTop clearfix">
                            <img :src="item.isChecked?'/cloud/checked.png':'/cloud/check.png'" @click="selectProP(item.company_id)" class="carClassAll"/>
                            <img :src="item.company_logo" class="carClassImg"/>
                            <div class="carClassName">{{item.company_name}}</div>
                        </div>
                        <div class="carClassBox">
                            <div class="carClassBoxC" v-for="list in item.list" :key="list.id" @click="selectPro(item.id,list.id)">
                                <div class="carCBg"></div>
                                <div class="carC clearfix">
                                    <div class="carCBox clearfix">
                                        <img :src="list.isChecked?'/cloud/checked.png':'/cloud/check.png'" class="carClasscheck"/>
                                        <div class="carContent clearfix">
                                            <img :src="list.thumbnail?list.thumbnail:'/cloud/product.png'" class="carClassProImg"/>
                                            <div class="carContentC">
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">品名:</div>
                                                    <div class="contantC">{{list.breed}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">等级:</div>
                                                    <div class="contantC">{{list.grade}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">片数:</div>
                                                    <div class="contantC">{{list.pieces}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">挂牌价:</div>
                                                    <div class="contantC">{{list.price}}</div>
                                                </div>
                                            </div>
                                            <div class="carContentC">
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">品牌:</div>
                                                    <div class="contantC">{{list.brand}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">规格:</div>
                                                    <div class="contantC">{{list.spec}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">方数:</div>
                                                    <div class="contantC">{{list.cube}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">状态:</div>
                                                    <div class="contantC carContentCar">{{list.status_text}}</div>
                                                </div>
                                            </div>
                                            <div class="carContentC">
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">区域-仓库:</div>
                                                    <div class="contantC">{{list.inventory_city+"-"+list.warehouse}}</div>
                                                </div>
                                                <div class="carContentCBox clearfix">
                                                    <div class="contentName">捆包号:</div>
                                                    <div class="contantC">{{list.bale_no}}</div>
                                                </div>
                                            </div>
                                            <div class="carContentPhone clearfix">
                                                <img src="/cloud/share7.png" class="carContentPhoneImg"/>
                                                <div class="carPhone">{{list.company_phone}}</div>
                                            </div>
                                        </div>
                                        <img src="/cloud/shoppingDel.png" @click.stop="delShop(list.id)" class="carClassProDelImg"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="selectMessBox clearfix">
                    <div class="carAllCheckedBox clearfix" @click="selectProAll">
                        <img :src="allChecked?'/cloud/checked.png':'/cloud/check.png'" class="carClassAll"/>
                        <div class="carAllCheckedName">全选</div>
                    </div>
                    <div class="selectMess">选中件数：{{selectNumber}}件</div>
                    <div class="selectMess">选中方数：{{selectCube}}m³</div>
                    <div class="selectMess">合计金额：￥{{selectPrice}}</div>
                    <div class="createBill" @click="createBill">生成现货采购单</div>
                    <div class="batchDelBill" @click="batchDelBill">批量删除</div>
                </div>
            </div>
            <div v-else class="noShopBox">
                <div class="noShop clearfix">
                    <img src="/cloud/shoppingCarC.png" class="noShopImgC"/>
                    <img src="/cloud/shoppingCarCT.png" class="noShopImg"/>
                    <div class="noshopTipBox">
                        <div class="tip">采购单空空的~ 快去添加需要的商品吧~</div>
                        <div class="gotoShop" @click="gotoShop">前往云链</div>
                    </div>
                </div>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import bottom from './component/bottom.vue'
export default {
    data(){
        return{
            carList:[],
            total:0,
            selectCube:0,
            selectNumber:0,
            selectPrice:0,
            allChecked:false,
            param:{
                keyword:""
            }
        }
    },
    components:{
        bottom
    },
    created(){
        this.getList()
    },
    methods:{
        batchDelBill(){
            let arr = new Array();
            this.carList.forEach(item=>{
                item.list.forEach(li=>{
                    if(li.isChecked){
                        arr.push(li.id)
                    }
                })
            })
            if(arr.length<=0){
                this.tip("请选择货物","warning")
                return;
            }
            this.$confirm('是否确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/cloud.cart.delete",{id:arr},()=>{
                    this.tip("删除成功","success")
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        gotoShop(){
            this.$router.push("/shopMall")
        },
        createBill(){
            let arr = new Array();
            this.carList.forEach(item=>{
                item.list.forEach(li=>{
                    if(li.isChecked){
                        arr.push(li.id)
                    }
                })
            })
            if(arr.length<=0){
                this.tip("请选择货物","warning")
                return;
            }
            this.$confirm('是否确定生成现货采购单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/cloud.order.create",{car_ids:arr},()=>{
                    this.tip("生成现货采购单成功","success")
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        calSelect(){
            let num = 0;
            this.selectCube = 0;
            this.selectNumber = 0;
            this.selectPrice = 0;
            this.carList.forEach(item=>{
                item.list.forEach(li=>{
                    if(li.isChecked){
                        this.selectCube = this.keepLimit(Number(li.cube)+this.selectCube)
                        this.selectNumber = ++num;
                        this.selectPrice = this.keepPrice((Number(li.price)*li.cube)+this.selectPrice)
                    }
                })
            })
        },
        selectProAll(){
            this.allChecked = !this.allChecked;
            this.carList.forEach(item=>{
                item.isChecked = this.allChecked;
                item.list.forEach(li=>{
                    li.isChecked = this.allChecked;
                })
            })
            this.calSelect()
        },
        selectProP(id){
            let flag = true;
            this.carList.forEach(item=>{
                if(item.company_id == id){
                    item.isChecked = !item.isChecked;
                    item.list.forEach(li=>{
                        li.isChecked = item.isChecked;
                    })
                }
                if(!item.isChecked){
                    flag = false;
                }
            })
            this.allChecked = flag;
            this.calSelect()
        },
        selectPro(pid,id){
            let flagC = true;
            this.carList.forEach(item=>{
                if(item.id == pid){
                    let flag = true;
                    item.list.forEach(li=>{
                        if(li.id == id){
                            li.isChecked = !li.isChecked;
                        }
                        if(!li.isChecked){
                            flag = false;
                        }
                    })
                    item.isChecked = flag;
                }
                if(!item.isChecked){
                    flagC = false;
                }
            })
            this.allChecked = flagC;
            this.calSelect()
        },
        delShop(id){
            this.$confirm('是否确定从购物车删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFunc("/erp/cloud.cart.delete",{id:id},()=>{
                    this.tip("删除成功","success")
                    this.getList();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        getList(type){
            this.postFunc("/erp/cloud.cart.list",this.param,res=>{
                if(type){
                    this.tip("查询成功","success")
                }
                let data = res.data.data;
                this.total = 0;
                data.forEach(item=>{
                    item.isChecked = false;
                    item.list.forEach(li=>{
                        li.isChecked = false;
                        this.total ++;
                    })
                })
                this.carList = data;
                this.calSelect()
            },error=>{
                this.tip(error.data.message,"warning")
            })
        }
    }
}
</script>
<style scoped>
    .cloudReturnBox:hover .cloudReturn{
        animation:backCloud 1s infinite;
        -moz-animation:backCloud 1s infinite;
        -webkit-animation:backCloud 1s infinite;
        -o-animation:backCloud 1s infinite;
    }
    @keyframes backCloud{0%{left:0;}80%{left:-10px;}100%{left:0;}}
    @-moz-keyframes backCloud{0%{left:0;}80%{left:-10px;}100%{left:0;}}
    @-webkit-keyframes backCloud{0%{left:0;}80%{left:-10px;}100%{left:0;}}
    @-o-keyframes backCloud{0%{left:0;}80%{left:-10px;}100%{left:0;}}
    .carClassBoxC:hover .carClasscheck{
        animation:checkbox 1s infinite;
        -moz-animation:checkbox 1s infinite;
        -webkit-animation:checkbox 1s infinite;
        -o-animation:checkbox 1s infinite;
    }
    @keyframes checkbox{0%{transform: scale(1);}20%{transform: scale(1.2);}100%{transform: scale(1);}}
    @-moz-keyframes checkbox{0%{transform: scale(1);}20%{transform: scale(1.2);}100%{transform: scale(1);}}
    @-webkit-keyframes checkbox{0%{transform: scale(1);}20%{transform: scale(1.2);}100%{transform: scale(1);}}
    @-o-keyframes checkbox{0%{transform: scale(1);}20%{transform: scale(1.2);}100%{transform: scale(1);}}



    .cloudReturnBox{float: right;margin-top:20px;cursor: pointer;}
    .cloudReturn{height:20px;display: block;float: left;margin-right:5px;position: relative;}
    .cloudReturnName{font-size: 14px;color:#fff;float: left;line-height:20px;}
    .noShopImgC{display: block;width:300px;margin-bottom:0px;}

    .carAllCheckedBox{float: left;margin-right:10px;cursor: pointer;margin-top:6px;}
    .carAllCheckedBox .carClassAll{float: left;margin-right:5px;width:14px;height:14px;margin-top:2px;}
    .carAllCheckedName{float: left;font-size: 12px;}

    .noShopBox{text-align: center;padding:80px 0;}
    .noShop{display: inline-block;}
    .noShopImg{width:19px;display: block;float: left;margin-top:2px;}
    .noshopTipBox{float: left;margin-left:5px;}
    .noshopTipBox .tip{font-size: 14px;color:#777;padding-bottom:20px;}
    .noshopTipBox .gotoShop{width: 80px;height: 30px;line-height: 28px;border: 1px solid #b21111;font-size: 14px;color: #fff;text-align: center;background-color: #b21111;cursor: pointer;border-radius: 3px;margin:auto;}

    .selectMessBox{padding:20px;box-shadow: 0 0 5px #e4e4e4;margin-top:20px;}
    .selectMess{font-size: 14px;float: left;margin-right:20px;height: 30px;line-height: 28px;}
    .createBill{width: 120px;height: 30px;line-height: 28px;border: 1px solid #b21111;font-size: 14px;color: #fff;text-align: center;float: right;background-color: #b21111;cursor: pointer;border-radius: 3px;}
    .batchDelBill{width: 80px;height: 30px;line-height: 28px;border: 1px solid #b21111;font-size: 14px;color: #fff;text-align: center;float: right;background-color: #b21111;cursor: pointer;border-radius: 3px;margin-right:10px;}

    .carContent{width:1100px;margin: auto;}
    .carTop{margin-top:30px;}
    .carTop .all{font-size: 18px;color:#b21111;float: left;cursor: pointer;font-weight: 600;line-height: 30px;}
    .carSearchBox{float: right;}
    .carSearchInp{width:200px;height:30px;line-height: 30px;font-size: 12px;border:0;border:1px solid #b21111;float: left;padding-left:10px;outline: none;}
    .searchBtn{width:80px;height:30px;line-height: 28px;border:1px solid #b21111;font-size: 14px;color:#fff;text-align:center;float: left;background-color: #b21111;cursor: pointer;}
    .carClass{}
    .carClass .carClassTop{margin-top:20px;padding:0 20px;}
    .carClass .carClassImg{display: block;width: 30px;float: left;}
    .carClass .carClassName{font-size: 16px;font-weight: 600;float: left;line-height: 30px;margin-left:10px;}
    .carClass .carClassAll{width:14px;height: 14px;display: block;float: left;margin-top:8px;margin-right:10px;cursor: pointer;}
    .carClass .carClassBox{width:100%;box-sizing: border-box;box-shadow: 0 0 5px #e4e4e4;margin-top:5px;}
    .carClassBoxC{padding:10px 20px;position: relative;}
    .carClassBoxC:hover .carCBg{width:100%;}
    .carCBox{z-index:1;position: relative;}
    .carCBg{z-index:0;position: absolute;width:0;height:100%;background-color: #EAEAF4;transition: 0.2s ease-out;left:0;right:0;margin:auto;top:0;}
    .carClass .carC{position: relative;padding:20px 24px;border-bottom:1px solid #dadada;cursor: pointer;}
    .carClass .carC:last-child{border-bottom:0;}
    .carClass .carClasscheck{width:14px;height:14px;position: absolute;top:0px;left:-25px;cursor: pointer;}
    .carClass .carClassProImg{width:100px;height:100px;display: block;float: left;}
    .carClass .carContent{float: left;}
    .carClass .carContentC{float: left;}
    .carClass .carContentCBox{margin-bottom:11px;}
    .carClass .carContentCBox:nth-child(4n){margin-bottom:0;}
    .carClass .contentName{width:80px;text-align: right;float: left;font-size: 13px;color:#333;}
    .carClass .contantC{float: left;font-size: 13px;font-weight: 600;padding-left:5px;width:150px;}
    .carClass .carClassProDelImg{width:20px;position: absolute;top:20px;right:0;cursor: pointer;transition: 0.8s ease-out;}
    .carClassProDelImg:hover{transform: rotateY(360deg);}
    .carClass .carContentPhone{float: left;}
    .carClass .carContentPhoneImg{width:12px;display: block;float: left;margin-top:2px;margin-right:5px;}
    .carClass .carPhone{font-size: 13px;float: left;color:#333;}



    .cloud{padding-top:60px;min-height: 100vh;padding-bottom:252px;box-sizing: border-box;position: relative;}
    .top{width:100%;position: fixed;top:0;left:0;min-width: 1200px;height: 60px;z-index:9;}
    .topBg{width:100%;height: 100%;background-color: #35363A;position: absolute;z-index:0;}
    .topContent{width:1200px;margin: auto;height: 60px;position: relative;z-index:1;}
    .topLogo{width:160px;display: block;float: left;margin-top:10px;}
    .CloudBanner{width:100%;display: block;min-width: 1200px;}
    .meunList{float: right;margin-top:13px;}
    .meun{display: inline-block;color:#fff;margin-left:50px;padding:5px 0;font-size: 14px;letter-spacing: 1px;}
    .meunChecked{color:#5AF7F1;border-bottom:2px solid #5AF7F1;}
    .topF .topBg{opacity: 1;background-color: #d2dde4;}
    .topF .topContent .meun{color: #000;}
    .topF .topContent .meunChecked{color:#b21111;border-bottom:2px solid #b21111;}
</style>